export default __webpack_public_path__ + "static/logo.arbeiterkammer-1d4c1452bb841828b4077f1fd197ee63.png";